/*
 * @Author: Teemo Ding
 * @Date: 2021-09-24 09:54:23
 * @LastEditTime: 2021-10-08 14:38:23
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DestinationAddressLocalisation/SubdivisionTranslation/index.tsx
 */
import { Form } from 'antd';
import React from 'react';

import SubdivisionTranslationSetting from '../Components/SubdivisionTranslationSetting';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../css.module.less';

const SubdivisionTranslation = ({
  value: shopperTransSettings = [],
  onChange,
  notEditable,
  form,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.itemBlock}>
      <div className={styles.header}>
        <div className={styles.title}>
          {getI18n(
            'storeLogistics.destinationAddressLocalisation.subdivisionPickerTranslation',
          )}
        </div>
      </div>
      <div className={`${styles.subdivisionTranslation} ${styles.content}`}>
        <Form.Item
          shouldUpdate={(prevValues, curValues) => {
            return prevValues.supportedLanguage !== curValues.supportedLanguage;
          }}>
          {({ getFieldValue }: any) => (
            <Form.Item name='subdivisions'>
              <SubdivisionTranslationSetting
                notEditable={notEditable}
                getFieldValue={getFieldValue}
              />
            </Form.Item>
          )}
        </Form.Item>
      </div>
    </div>
  );
};

export default SubdivisionTranslation;
